<template>
    <div>
        <template v-if="poc === true">
            <div class="page-top mb-1 mb-3 align-center clearfix">
                <h1 class="float-left"> POC </h1>
                    <router-link to="/addPoc" class="btn btn-primary float-right active"> Add New POC</router-link>
                <div class="searching float-right mr-2">
                    <input id="customSearch" type="text" class="form-control search" name="" />
                </div>
            </div>
            <table id="pocTable" class="table">
                <thead>
                    <tr>
                        <th style="display: none;"></th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>City</th>
                        <th>Region</th>
                        <th>Source</th>
                        <th class="text-center">Action</th>
                    </tr>
                </thead>
            </table>
        </template>
        <template v-else-if="poc === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="poc === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                data : null,
                poc : null,
            };
        },
        mounted() {
            this.$Progress.start();
            this.can('poc').then(result => {
                this.poc = result.poc;
            }).then(result => {
                if(this.poc == true){
                    this.callDatatable();
                    this.$Progress.finish();
                }else{
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            callDatatable(){
                var pocTable = $('#pocTable').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "api/listPocs",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'name'},
                        {data: 'email'},
                        {data: 'phone'},
                        {render: function(data,type,full){
                            if(full.city != null){
                                return full.city.name;
                            }
                        }},
                        {render: function(data,type,full){
                            // return full.region.name;
                        }},
                        {data: 'source'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            var $url = '/editPoc/'+full['id'];
                            return '<a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" class="action edit"><i class="fas fa-pencil-alt"></i></a>';
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "columnDefs": [{
                        className: "text-center",
                        "targets": [ 7 ]
                    }],
                    "initComplete": () => {
                        this.$Progress.finish();
                    }
                });
                // $('#customSearch').on( 'keyup', function () {
                //     pocTable.search(this.value).draw();
                // });
            }
        },
    }
</script>
